/* global ga, uaCode */
var selectedProduct = null
import googleTagLinker from '@giovaniortolanibarbosa/google-tag-linker'
    
const templateCss = (cssclass, _template) => {
    if(_template === 'template1') {
        return cssclass
    }

    return `${_template}-${cssclass}`
}

var proceedCheckout = function () {
    console.log("proceedcheckout")
    $.ajax({
        type: 'POST',
        url: 'basket/api/validate-basket',
        data: {
            basket: basket.getBasketJson()
        },
        success: function (data) {
            if (
                data.hasOwnProperty('redirect') &&
                data.redirect.hasOwnProperty('url')
            ) {
                let decoratedUrl = getTrackerObject(data.redirect.url)
                window.location = decoratedUrl
            } else if (data.hasOwnProperty('validate')) {
                if (data.validate.productMissing) {
                    var message = basket.restaurant.translations.productMissingBasketSingular
                    if (data.validate.productMissings.length > 1) {
                        var message = basket.restaurant.translations.productMissingBasketPlural
                    }
                    $('.basket-notification').text(message).show()
                }

                if (data.validate.productMismatch) {
                    var message = basket.restaurant.translations.productMismatchSingular

                    if (data.validate.productMismatches.length > 1) {
                        var message = basket.restaurant.translations.productMismatchPlural
                    }
                    $('.basket-notification').text(message).show()
                }
                basket.updateBasketAfterValidation(data.validate)
            }
        }
    })
}
/* SIDEDISHES */
const menucard_ShowSideDishes = function (productId, categoryId, minAge, template) {
    if (canAddItemToCart(template) === false) {
        return false
    }

    let minAgeValue =  parseInt(minAge)
    if(isNaN(minAgeValue) || minAgeValue <= 0) {
        minAgeValue = null
    }

    menucard_SidedishPopup(productId, categoryId, minAgeValue, template)
    return false
}
/** pulldown in sidedish pop-in update inline description
 *
 */
const changeSidedishDescription = function (pulldownselector, productid) {
    selectedValue = $(pulldownselector).find(':selected').val();
    // hide descriptors except the one belonging to the selected value
    $('.inline-desc > span', $(pulldownselector).parent()).each(function () {
        if ($(this).attr('id') != selectedValue) {
            $(this).addClass('hidden');
        } else {
            $(this).removeClass('hidden');
        }
    });
}
const menucard_SidedishPopup = function (productId, categoryId, minAge = null, template = 'template1') {

    // prepare post variables
    $.ajax({
        type: 'POST',
        url: 'basket/api/add-sidedish',
        data: {
            action: 'add',
            menucat: categoryId,
            product: productId,
            rest: basket.restaurant.id,
            template
        },
        headers: {
            'Cache-Control': 'no-cache'
        },
        dataType: 'html',
        success: function (data) {

            var obj = $.parseJSON(data)

            if (obj) {

                var formId = productId

                console.log($('#isidedishselectionform' + formId))

                productId = $('input[name="product"]', '#isidedishselectionform' + formId).val()
                console.log('menucard_ShowSideDishes() success: productId', productId)
                // Get the product from the object literal and pass the size/sidedishes into it.
                var id
                // find() returns 'undefined' if nothing found
                var sidedish = obj.json.find(function (x) {
                    return x.id === productId
                });

                console.log(sidedish)

                id = sidedish
                    ? sidedish.id
                    : obj.json[0].id // Old way fallback: Get the first sidedish

                selectedProduct = basket.products
                    .filter(
                        function (x) {
                            return x.productId === id && x.categoryId !== '0'
                        })[0]
                console.log('menucard_ShowSideDishes() success: selectedProduct', selectedProduct)

                selectedProduct.sizes = obj.json
                // By default the first size is selected.
                selectedProduct.sizes[0].isSelected = true
                // If the sidedish group is a pull down, then the first one will be selected.
                for (var x in selectedProduct.sizes) {
                    var size = selectedProduct.sizes[x]
                    if (size.sidedishes !== false) {
                        for (var xx in size.sidedishgroups) {
                            var sidedishGroup = size.sidedishgroups[xx]
                            // Pulldown could be either 1 or 3?
                            if (sidedishGroup.type === '1' || sidedishGroup.type === '3') {
                                sidedishGroup.sidedishes[0].isSelected = true
                            }
                        }
                    }
                }

                const selector = templateCss('sidedishpopup', template)

                $(`#${selector}`).popup('init', selector)
                $(`#${selector}`).html(obj.html)
                $(`#${selector} input[type="text"]`).first().focus()
            }

        }
    })
}
// Add product with size/sidedishes to basket
const menucard_AddExtendedProductToBasket = function (productId) {
    if (canAddItemToCart() === false) {
        return
    }

    console.log(selectedProduct)

    let minAges = []
    let minAge = null
    selectedProduct.sizes.forEach((size) => {
        if (size.isSelected === true) {
            if (size.hasOwnProperty('minAge')) {
                minAges.push(size.minAge)
            }
            size.sidedishgroups.forEach((sdg) => {
                let sidedishes = sdg.sidedishes
                sidedishes.forEach((sd) => {
                    if (sd.isSelected === true && sd.hasOwnProperty('minAge')) { //  && size.minAge !== undefined
                        minAges.push(sd.minAge)
                    }
                })
            })
        }
    })

    if (minAges.length) {
        minAge = Math.max(...minAges)
        if (Number.isInteger(minAge) && minAge > 0 && !basket.hasProductsForMinAge(minAge)) {
            return basket.showAgeVerificationConsentMessage(productId, minAge, true)
        }
    }

    addSideDishBasket(productId, minAge)
}

const addSideDishBasket = function (productId, minAge = null) {
    if (canAddItemToCart() === false) {
        return
    }

    for (let x in selectedProduct.sizes) {
        let size = selectedProduct.sizes[x]
        if (size.id === productId) {
            basket.addProduct(selectedProduct.productId, minAge)
            menucard_CloseSideDishes()
            delete selectedProduct.sizes
            selectedProduct = null
            return false
        }
    }
    throw new Error('Product mismatched')
}

const showEmergencyMessage = function () {
    if (site.emergency) {
        var EmergencyClosed = $('#emergencymessage').text()
        if (EmergencyClosed) {
            toast(EmergencyClosed)
        }
        return true
    }
    return false
}
// Show notification that delivery area info is needed
const menucard_DeliveryAreaNeeded = function (restid, template = 'template1') {
    $.ajax({
        type: 'GET',
        url: 'basket/api/delivery-area',
        success: function (data) {
            if (data.length > 0) {
                $('#'+ template).popup('init',template)
                $('#'+ template).html(data)
                $('#'+ template + 'input[type="text"]').first().focus()
            } else {
                $('.shoppingcart').addClass('update')
                setTimeout(function () {
                    $('.shoppingcart').removeClass('update')
                }, 300)
            }
        }
    })

    return false
}
const isDeliveryPossible = function () {

    let deliveryArea = getUsersDeliveryAreaId()
    let postCode = Cookies.get('postcode')
    // searchString may be like '7522 dc', so remove spaces and make it uppercase
    let searchString = Cookies.get('searchstring')
    searchString = typeof searchString === 'string' ? searchString.replace(/\s/g, '').toUpperCase() : ''

    // prevent backbutton being pressed and using outdated lat lng data to calculate polygons
    if (site.cc == 45) {
        if (typeof postCode !== 'undefined') {
            if (deliveryArea !== formatQueryPostcode(postCode)) {
                polygons = false
            }
        }
    }

    // if pickup, deliveryarea isnt needed
    if (basket.restaurant.deliveryType !== 1 && !deliveryArea) {
        console.log('isDeliveryPossible(): true, pickup mode')
        return true
    }

    if (!deliveryArea) {
        console.log('isDeliveryPossible(): false, no getUsersDeliveryAreaId()')
        return false
    }

    // @TODO add postcodesupport ; siteconfig haspostcode (normal vs vietnam)
    // if (basket.restaurant.settings.postcodesupport) {
    if (true) {
        // All countries
        if (hasRestaurantDeliveryAreaForPostcodeSearch(deliveryArea)) {
            console.log('isDeliveryPossible(): user is inside a postcode:', deliveryArea)
            return {searchType: 'postcode', postcode: deliveryArea}
        }
    } else {
        // Vietnam
        let realDeliveryArea = hasRestaurantDeliveryAreaForPostcodeSearch(deliveryArea, true)
        if (realDeliveryArea) {
            console.log('isDeliveryPossible(): (vietnam) user is inside a postcode:', realDeliveryArea, 'original input:', deliveryArea)
            return {searchType: 'postcode', postcode: realDeliveryArea}
        }
    }

    console.log('isDeliveryPossible(): false, no delivery to:', deliveryArea)
    return false
}
const menucard_CloseSideDishes = function () {
    const modal = $('#modalSideDish')
    if (modal.length) {
        const templateClass = modal.data('template-class')
        modal.popup('close', templateClass)
    }

}
const showSize = function (selectedValue) {
    selectedValueParts = selectedValue.split(';')
    productid = selectedValueParts[0]

    $('.sidedishformcontainer').addClass('hidden')
    $('#isidedishformcontainer' + productid).removeClass('hidden')

    $('.sizeattributecontainer').addClass('hidden')
    $('#sizeattributecontainer' + productid).removeClass('hidden')

}
/** Add one to the values currently in the DOM elements with
 *  the given (comma separated) targetids up to a given maximum (or 99)
 */
var pmButtonAddOne = function (targetids, maximum) {
    if (maximum == undefined) maximum = 99

    // function supports multiple ids passed through targetids parameter
    var target_id_array = targetids.split(',')
    if (target_id_array.length > 1) {
        // call this function again for each single element in targetids
        for (i = 0; i < target_id_array.length; i++) {
            pmButtonAddOne(target_id_array[i], maximum)
        }
    } else {
        // there is only one element in targetids
        var targetid = target_id_array[0]

        target_element = document.getElementById('i' + targetid)
        if (target_element != null) {
            if (target_element.tagName == 'INPUT') {
                cur_value = parseInt(target_element.value)
                if (cur_value < maximum) {
                    target_element.value = cur_value + 1
                } else {
                    target_element.value = maximum
                }
            } else {
                cur_value = parseInt(target_element.innerHTML)
                if (cur_value < maximum) {
                    target_element.innerHTML = cur_value + 1
                } else {
                    target_element.innerHTML = maximum
                }
            }
        }
    }
}
/** Subtract one off the values currently in the DOM elements with
 *  the given (comma separated) targetids down to a given minimum (or 1)
 */
const pmButtonSubtractOne = function (targetids, minimum) {
    if (minimum == undefined) minimum = 0

    // function supports multiple ids passed through targetids parameter
    var target_id_array = targetids.split(',')
    if (target_id_array.length > 1) {
        // call this function again for each single element in targetids
        for (i = 0; i < target_id_array.length; i++) {
            pmButtonSubtractOne(target_id_array[i], minimum)
        }
    } else {
        // there is only one element in targetids
        var targetid = target_id_array[0]

        target_element = document.getElementById('i' + targetid)
        if (target_element != null) {

            if (target_element.tagName == 'INPUT') {
                cur_value = parseInt(target_element.value)
                if (cur_value > minimum) {
                    target_element.value = cur_value - 1
                } else {
                    target_element.value = minimum
                }
            } else {
                cur_value = parseInt(target_element.innerHTML)
                if (cur_value > minimum) {
                    target_element.innerHTML = cur_value - 1
                } else {
                    target_element.innerHTML = minimum
                }
            }
        }
    }
}
const getUsersDeliveryAreaId = function () {
    let postcode = Cookies.get('postcode')
    // Remove letters from postcode: e.g. 8766TS > 8766
    if (typeof postcode !== 'undefined') {
        postcode = formatQueryPostcode(postcode)
        postcode = fomatQuerySplitPostcode(postcode)
    }
    // If deliveryAreaId cookie is like '8888-alpha', use it instead of '8888'
    if (typeof postcode !== 'undefined') {
        let deliveryAreaId = Cookies.get('deliveryareaid')
        if (
            typeof deliveryAreaId !== 'undefined' &&
            postcode !== deliveryAreaId &&
            postcode === deliveryAreaId.split('-')[0]
        ) {
            postcode = deliveryAreaId
            console.log('getUsersDeliveryAreaId(): (split postcode) return: ', deliveryAreaId)
        }
    }

    // If website is Vietnam, take 'searchstring2' as postcode
    if (typeof postcode === 'undefined' &&
        Cookies.get('searchstring1') &&
        Cookies.get('searchstring2')) {
        postcode = Cookies.get('searchstring2')
        console.log('getUsersDeliveryAreaId(): (vietnam) return:', postcode)
    }

    /**
     * Set customer cookies if urlhash exists of a valid postcode
     *
     */
    return (typeof postcode !== 'undefined')
        ? postcode
        : null
}
const formatQueryPostcode = function (postcode) {
    if (site.cc == 180 || site.cc == 239) { // Poland
        return postcode
    } else if (site.cc == 181) { // Portugal
        let reg = new RegExp('[^0-9-]', 'g')
        return postcode.replace(reg, '')
    } else { // all other
        let reg = new RegExp('[^0-9]', 'g')
        return postcode.replace(reg, '')
    }
    return postcode
}
const fomatQuerySplitPostcode = function (postcode) {
    // for now only do this for Netherlands / Belgium / Lieferservice
    if (site.cc != 1 && site.cc != 3 && site.cc != 6) {
        return postcode
    }

    var splitpc = Cookies.get('deliveryareaid')
    if (typeof splitpc != 'undefined') {
        var reg = new RegExp('[^0-9]', 'g')
        if (postcode.replace(reg, '') == splitpc.replace(reg, '')) {
            return splitpc
        }
    }
    return postcode
}
const hasRestaurantDeliveryAreaForPostcodeSearch = function (postcode, returnLocation = false) {
    for (let i in basket.restaurant.deliveryAreas) {
        let area = basket.restaurant.deliveryAreas[i]

        // This is especially for Vietnam
        if (returnLocation) {
            if (postcode === area.locationid.toString()) {
                return area.id.toString()
            }
        } else {
            if (postcode === area.id.toString()) {
                return true
            }
        }
    }
    return false
}

const addSimpleProductBasket = function (clickEvent, template) {

    if (canAddItemToCart(template) === false) {
        return false
    }

    let target = clickEvent.target;

    if(clickEvent.target.tagName !== 'A'){
        target = clickEvent.target.closest('.addtobasket');
    }

    let dataset = target.dataset

    let minAge = parseInt(dataset.minAge)

    if(isNaN(minAge) || minAge <= 0) {
        return addBasket(dataset.productid)
    }

    if(!basket.hasProductsForMinAge(minAge)) {
        return basket.showAgeVerificationConsentMessage(dataset.productid, minAge)
    }

    return addBasket(dataset.productid, minAge)
}

/**
 * add checks of restaurant closed, deliveryNeeded and emergency
 * in one function
 * @returns {boolean}
 */
const canAddItemToCart = function (template) {
    if (showEmergencyMessage()) {
        return false
    }

    if (!isDeliveryPossible()) {
        menucard_DeliveryAreaNeeded(basket.restaurant.id, template)
        return false
    }

    // Check if restaurant is Open
    if (basket.restaurant.isClosed()) {
        basket.showRestaurantIsClosed()
        return false
    }
    return true
}

const addBasket = function (productId, minAge = null) {

    if (canAddItemToCart() === false) {
        return false
    }

    basket.addProduct(productId, minAge)
    selectedProduct = null
    return false
}

const toast = function (text) {
    const $elem = $('#tooltip')
    $elem
        .html(text)
        .show()
        .delay(3000)
        .fadeOut(200, () => $elem.text(''))
}
const getCurrentDelivery = (deliveryType) => {
    let currentDelivery = isDeliveryPossible()
    if (currentDelivery &&
        (
            currentRestaurant.Pickup === ENUM.DeliveryMethod.Type.DeliveryAndPickup ||
            deliveryType === ENUM.DeliveryMethod.Type.Delivery
        )) {
        // Nothing to do, but "takeaway/pickup logic" above should be simplified.
        // We already calculate "pickup" condition in MenuCard.js::isDeliveryPossible()
    } else {
        currentDelivery = false
    }

    console.log('%c ======= currentDelivery ========= ', 'background: #efefef; color: #333', currentDelivery)

    return currentDelivery
}

export function helperInit() {

    window.selectedProduct = null
    window.hasRestaurantDeliveryAreaForPostcodeSearch = hasRestaurantDeliveryAreaForPostcodeSearch
    window.addBasket = addBasket
    window.addSimpleProductBasket = addSimpleProductBasket
    window.addSideDishBasket = addSideDishBasket
    window.canAddItemToCart = canAddItemToCart
    window.fomatQuerySplitPostcode = fomatQuerySplitPostcode
    window.formatQueryPostcode = formatQueryPostcode
    window.getUsersDeliveryAreaId = getUsersDeliveryAreaId
    window.pmButtonSubtractOne = pmButtonSubtractOne
    window.pmButtonAddOne = pmButtonAddOne
    window.showSize = showSize
    window.menucard_ShowSideDishes = menucard_ShowSideDishes
    window.isDeliveryPossible = isDeliveryPossible
    window.menucard_DeliveryAreaNeeded = menucard_DeliveryAreaNeeded
    window.showEmergencyMessage = showEmergencyMessage
    window.menucard_AddExtendedProductToBasket = menucard_AddExtendedProductToBasket
    window.menucard_SidedishPopup = menucard_SidedishPopup
    window.changeSidedishDescription = changeSidedishDescription
    window.allergens = allergens
    window.proceedCheckout = proceedCheckout
    window.toast = toast
    window.getCurrentDelivery = getCurrentDelivery

    $(document).on('click', '.staticBasket .baskettitle', function () {

        $('.staticBasket').toggleClass('opened')
    })
    $(document).on('click', '.closepopup', function () {
        menucard_CloseSideDishes()
    })
    /**
     * When change product size.
     */
    $(document).on('change', '#isizeselection', function (e) {

        var id = $(e.target.options[e.target.options.selectedIndex]).data('id')
        const minAge = parseInt($(e.target.options[e.target.options.selectedIndex]).data('min-age'))
        for (var x in selectedProduct.sizes) {
            var size = selectedProduct.sizes[x]
            size.isSelected = false
            if (size.id === id) {
                size.isSelected = true
                if (Number.isInteger(minAge) && minAge > 0) {
                    size.minAge = minAge
                }
            }
        }
    })
    /**
     * When clicked on sidedish checkbox.
     */
    $(document).on('click', '.templaterevamped-sidedishes .sidedish-checkbox input', function (e) {
        onCheckboxClick(e);
    })

    $(document).on('click', '.sidedishes .sidedish-checkbox input', function (e) {
        onCheckboxClick(e);
    })
    /**
     * onCheckboxClick
     * @param e
     * Created a separate function so we can have 2 click events for both templates
     */
    const onCheckboxClick = function (e) {
        var isChecked = e.target.checked
        var target = $(e.target)
        var id = target.data('sidedishid').toString()
        let minAge = parseInt(target.data('min-age'))
        for (var x in selectedProduct.sizes) {
            var size = selectedProduct.sizes[x]
            if (size.isSelected) {
                for (var xx in size.sidedishgroups) {
                    var group = size.sidedishgroups[xx]
                    for (var xxx in group.sidedishes) {
                        var sidedish = group.sidedishes[xxx]
                        if (sidedish.id === id) {
                            sidedish.isSelected = isChecked
                            if (Number.isInteger(minAge) && minAge > 0) {
                                sidedish.minAge = minAge
                            }
                            return
                        }
                    }
                }
            }
        }
    }

    /**
     * When change sidedish pull down
     */
    const onSideDishChange = function (e) {

        var id = $(e.target.options[e.target.options.selectedIndex]).data('sidedishid').toString()
        let minAge = parseInt($(e.target.options[e.target.options.selectedIndex]).data('min-age'))
        if (Number.isNaN(minAge) || minAge <= 0) {
            minAge = null
        }
        for (var x in selectedProduct.sizes) {
            var size = selectedProduct.sizes[x]
            if (size.isSelected) {
                for (var xx in size.sidedishgroups) {
                    var group = size.sidedishgroups[xx]
                    for (var xxx in group.sidedishes) {
                        var sidedish = group.sidedishes[xxx]
                        if (sidedish.id === id) {
                            sidedish.isSelected = true
                            sidedish.minAge = minAge
                            // Deselect the others fromt the same group.
                            // Very lame, but there is no group id to check where the side dish belongs to.
                            for (var xxxx in group.sidedishes) {
                                var s = group.sidedishes[xxxx]
                                if (s.id !== id) {
                                    s.isSelected = false
                                    if (s.hasOwnProperty('minAge')) {
                                        delete s.minAge
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    $(document).on('change', '.sidedishes .sidedish-select .select-input select', onSideDishChange)
    $(document).on('change', '.templaterevamped-sidedishes .templaterevamped-sidedish-select .select-input select', onSideDishChange)
    $(document).on('click', '#modal', function () {
        menucard_CloseSideDishes()
    })


    $.when($.ready).then(function () {
        const getPage = () => {
            let page = ENUM.PAGE.UNKNOWN

            if ($(document.body).hasClass('menu')) {
                page = ENUM.PAGE.MENU
            }

            if ($(document.body).hasClass('checkout')) {
                page = ENUM.PAGE.CHECKOUT
            }

            if ($(document.body).hasClass('menu') && $('.confirm').length > 0) {
                page = ENUM.PAGE.SUCCESS
            }
            return page
        }

        var page = getPage()
        console.log(page)

        // Clear the basket on step 5
        if (page === ENUM.PAGE.SUCCESS) {
            localStorage.removeItem(ENUM.Persistence.BASKET)
            localStorage.removeItem(ENUM.Persistence.LAST_INTERACTION_TIME)
            return
        }

        if (!(page === ENUM.PAGE.MENU || page === ENUM.PAGE.CHECKOUT)) {
            return
        }

        // Todo: add domain GET parameter to the get-restaurant.php if it is present in the originating request
        // Only then will minisite object be instantiated with a correct restaurant object on dev-machine.

        $.ajax({
            type: 'GET',
            url: 'basket/api/restaurant',
            success: function (data, textStatus, xhr) {
                // single call for server time
                var date = xhr.getResponseHeader('Date')
                // time zone
                moment.tz.add(site.tzData)
                moment.tz.setDefault(site.tz)
                // time = null // Uncomment this to test fallback on client time
                var time = date !== null
                    ? Number(moment(date).format('x'))
                    : moment.now()

                if (Cookies.get('overridedate')) {
                    var cookieDate = Cookies.get('overridedate')
                    time = Number(moment(cookieDate).format('x'))
                }

                // var currentDelivery = getCurrentDelivery(data.Pickup)
                var deliveryAreaId = Cookies.get('postcode')
                console.log('deliveryAreaId', deliveryAreaId)

                // checking if deliveryareaid isset than change postcode to deliveryareaid otherwise take postcode.
                if(typeof deliveryAreaId !== 'undefined') {
                    deliveryAreaId = formatQueryPostcode(deliveryAreaId)
                    deliveryAreaId = fomatQuerySplitPostcode(deliveryAreaId)
                }

                var currentDelivery = deliveryAreaId
                    ? {
                        'searchType': 'postcode',
                        'postcode': deliveryAreaId
                    }
                    : false;

                basket = new BasketInitiator({
                    categories: data.MenucardJson.categories,
                    currentRestaurant: data,
                    currentDelivery: currentDelivery,
                    deliveryType: ENUM.DeliveryMethod.Type.Delivery,
                    page: page,
                    products: data.MenucardJson.products,
                    showToastFunction: toast,
                    time: time
                })
                basket.proceedCheckout = proceedCheckout
                // debugger
            }
        })
    })


}

/**
 * Get the GA tracking URL parameter to be appended to the checkout redirect
 * @returns trackerObject | undefined
 */
const getTrackerObject = (url) => {
  const linkerParamName = "_ga"
  const linkerParam = googleTagLinker("get")

  // Extract _ga value from cookies
  const gaCookies = document.cookie
  .split("; ")
  .filter((cookie) => cookie.startsWith(linkerParamName));

  if (!gaCookies.length) {
      return url.includes("?") ? `${url}&${linkerParam}` : `${url}?${linkerParam}`;
  } 

  const urlObj = new URL(url);

  gaCookies.forEach(cookie => {
    const [name, val] = cookie.split("=");
    if (!urlObj.searchParams.has(name)) {
      urlObj.searchParams.append(name, val);
    }
  })

  urlObj.searchParams.forEach((_, param) => {
    if (param.startsWith("_gcl")) {
      urlObj.searchParams.delete(param);
    }
    if (param.startsWith("_ga")) {
      urlObj.searchParams.set(param, urlObj.searchParams.get(param));
    }
  });

  return urlObj.toString()
}
